module.exports = __webpack_public_path__ + "img/wrenchBlack.e5c74ef0.svg";